/**
 * Utility class that will return if the user is using a small device
 */
define([], () => {
    return (deviceBreakpoint = '768') => {
        return window.innerWidth <= deviceBreakpoint;
    };
});
